import {Ease} from "../../core/Animatable";
import {SceneItem} from "../SceneItem";
import {AnimationContext} from "./AnimationContext";
import {SlideInAnimation} from "./SlideInAnimation";

export class FloatInAnimation extends SlideInAnimation {

    public animate(item: SceneItem, context: AnimationContext, cb: () => void): void {
        if (this.type === "left" || this.type === "right") {
            if (!this.speed) {
                this.speed = 0.5;
            }
            const y = item.y - 100;
            let isSlideInComplete = false;
            let floatIteration = 0;
            const floatTween = item.moveYTo(y, 0.6, Ease.sineInOut, {
                delay: this.delay,
                repeat: -1,
                yoyo: true,
                onUpdate: () => this.updatePaperCut(item),
                onRepeat: () => {
                    if (isSlideInComplete && floatIteration % 2 > 0) {
                        floatTween.kill();
                        cb();
                    }
                    floatIteration++;
                },
            });
            super.animate(item, context, () => {
                isSlideInComplete = true;
            });
        } else {
            super.animate(item, context, cb);
        }
    }
}
